import { useQuery } from "@tanstack/react-query";
import { InfraAPI } from "@/lib/infra-api";
import { SlideOver } from "./SlideOver";
import { Download, FileText, Loader2 } from "lucide-react";

const REPORT_ICONS = {
  infrastructure_summary: "Infrastructure Summary — one-page KPI snapshot for exec review",
  room_utilization: "Room Utilization — capacity vs occupancy for every active room",
  exam_hall_capacity: "Exam Hall Capacity — rooms sorted by exam-ready seats",
  assets: "Assets — every asset category with count, vendor, warranty, AMC status",
  utilities: "Utilities — vendors, capacities, maintenance schedules",
  safety_compliance: "Safety Compliance — inspection dates, certificates and expiries",
};

export function ReportsPanel({ open, onClose, campusId }) {
  const q = useQuery({
    queryKey: ["infra-reports"],
    queryFn: () => InfraAPI.listReports(),
    enabled: open,
  });

  return (
    <SlideOver
      open={open}
      onClose={onClose}
      title="Reports"
      subtitle="Download infrastructure reports as CSV — open in Excel, Sheets or Numbers."
      width="max-w-3xl"
      testid="reports"
    >
      <div className="p-6 space-y-3">
        {q.isLoading ? (
          <div className="py-12 flex items-center justify-center text-slate-400">
            <Loader2 className="h-5 w-5 animate-spin" />
          </div>
        ) : (
          (q.data || []).map((r) => (
            <a
              key={r.kind}
              href={InfraAPI.reportUrl(r.kind, campusId)}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-4 p-4 rounded-xl border border-slate-200 bg-white hover:border-fuchsia-300 hover:shadow-md transition-all group"
              data-testid={`report-${r.kind}`}
            >
              <div className="h-11 w-11 rounded-xl bg-fuchsia-50 text-fuchsia-600 flex items-center justify-center shrink-0">
                <FileText className="h-5 w-5" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold text-slate-900">{r.label}</div>
                <div className="text-xs text-slate-500 truncate">{REPORT_ICONS[r.kind] || ""}</div>
              </div>
              <div className="inline-flex items-center gap-1 text-xs font-semibold text-slate-600 group-hover:text-fuchsia-600">
                <Download className="h-3.5 w-3.5" /> CSV
              </div>
            </a>
          ))
        )}
      </div>
    </SlideOver>
  );
}
